import { Heart } from 'lucide-react';
import { memo } from 'react';

import { addToFavoriteThunk, removeFromFavoritesThunk, useFavorites } from '@/screens/Favorites';
import { clsx } from 'clsx';

import { ACCENT } from '@shared/constants/colors';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Metrics } from '@shared/types/enums/metrics.enum';
import { Tooltip } from '@shared/ui/Tooltip';
import { sendMetrics } from '@shared/utils/sendMetrics/sendMetrics';

import cls from './FavoriteButton.module.scss';

type FavoriteButtonProps = {
  className?: string;
  productId: string;
  label?: {
    add: string;
    remove: string;
  };
  iconColor?: string;
  iconSize?: number;
};

export const FavoriteButton = memo(
  ({ className, productId, label, iconColor = ACCENT, iconSize = 22 }: FavoriteButtonProps) => {
    const favoriteProducts = useAppSelector((state) => state.favorites.productIds);
    const isFavorite = favoriteProducts.find((el) => el === productId);
    const dispatch = useAppDispatch();

    const { removeProduct } = useFavorites();

    const toggleFavorite = () => {
      if (isFavorite) {
        if (removeProduct) {
          removeProduct(productId);
        } else {
          dispatch(removeFromFavoritesThunk(productId));
        }
      } else {
        dispatch(addToFavoriteThunk(productId));
        sendMetrics(Metrics.LIKE_GOAL);
      }
    };

    return (
      <Tooltip label={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}>
        <button
          aria-label={'Добавить в избранное'}
          onClick={toggleFavorite}
          className={clsx(cls.wrap, className, { [cls.favorite]: isFavorite, [cls.withLabel]: label })}
        >
          <Heart
            size={iconSize}
            color={iconColor}
          />
          {label && <span className={cls.label}>{isFavorite ? label.remove : label.add}</span>}
        </button>
      </Tooltip>
    );
  }
);
